import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useAppDispatch } from "../../../../redux/store";
import AuthCode from "react-auth-code-input";
import { useInterval } from "../../../../hooks/useInterval";
import { formatPhone } from "../../../../utils";
import { fetchEditPhone, fetchSendPhoneCode } from "../../../../redux/profile/settings/changeDataProfile/asyncActions";
import styles from "../../../../components/PassChangeModal/Forms/SmsCodeForm/SmsCodeForm.module.scss";

type PhoneCodeFormProps = {
  phone: string;
  onSuccess: () => void;
  onCancel: () => void;
};

export const PhoneCodeForm: React.FC<PhoneCodeFormProps> = ({ phone, onSuccess, onCancel }) => {
  const dispatch = useAppDispatch();
  const [errorCode, setErrorCode] = React.useState(false);
  const [timer, setTimer] = React.useState(60);

  const initialValues = {
    code: [""],
  };

  const validationSchema = Yup.object({
    code: Yup.array().of(Yup.string().required("Required")),
  });

  const handleSubmit = async (values: { code: string[] }) => {
    const code = values.code.join("");
    setErrorCode(false);

    try {
      const result = await dispatch(fetchEditPhone({ phone, code: Number(code) }));
      
      if (result.payload === 200) {
        onSuccess();
      } else {
        setErrorCode(true);
      }
    } catch (error: any) {
      setErrorCode(true);
    }
  };

  const handleResendCode = async () => {
    try {
      await dispatch(fetchSendPhoneCode({ phone }));
      setTimer(60);
      setErrorCode(false);
    } catch (error) {
    }
  };

  useInterval(() => {
    setTimer(timer - 1);
  }, timer > 0 ? 1000 : null);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <p className={styles.description}>
              Код подтверждения отправлен на номер <br/> 
              <span className={styles.phone}>
                {formatPhone(phone)}
              </span>
            </p>

            <div className={styles.formSection}>
              <div className={styles.inputsWrapper}>
                <AuthCode
                  containerClassName={styles.inputsWrapper}
                  length={4}
                  inputClassName={`${styles.input} ${errorCode ? styles.input_error : ''}`}
                  allowedCharacters='numeric'
                  autoFocus
                  onChange={(v) => {
                    formik.setValues({ code: [v] });

                    if (v.length === 4) {
                      formik.handleSubmit();
                    }
                  }}
                />
              </div>
              {errorCode && (
                <div className={styles.errorMessage}>
                  Неверный код подтверждения
                </div>
              )}
            </div>

            <div className={styles.description}>
              {timer !== 0 ? (
                <span className={styles.timer}>
                  Отправить повторно через {' '}
                  <span className={styles.timer_time}>
                    {timer} сек.
                  </span>
                </span>
              ) : (
                <span
                  className={styles.resend}
                  onClick={async () => {
                    setErrorCode(false);
                    try {
                      await dispatch(fetchSendPhoneCode({ phone }));
                      setTimer(60);
                    } catch (error) {
                    }
                  }}
                >
                  Отправить код повторно
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

